import { Box, Drawer, IconButton, Stack, Typography, type DrawerProps } from '@mui/material';
import { Close } from '@mui/icons-material';

interface DrawerLayoutProps {
  open: boolean;
  onClose: () => void;
  title: string;
  titleIcon?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  slotProps?: DrawerProps['slotProps'];
}

export const DrawerLayout = ({ open, onClose, title, titleIcon, children, actions, slotProps }: DrawerLayoutProps) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    slotProps={
      slotProps ?? {
        paper: {
          sx: { borderRadius: 0, width: { xs: '100%', sm: 480 } },
        },
        root: {
          sx: { zIndex: 1300 },
        },
      }
    }
  >
    <Box
      sx={{
        display: 'flex',
        position: 'sticky',
        top: 0,
        backgroundColor: 'background.paper',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
        borderBottom: 1,
        borderColor: 'divider',
        zIndex: 100,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {titleIcon}
        <Typography variant="h6">{title}</Typography>
      </Stack>
      <IconButton onClick={onClose} size="small">
        <Close />
      </IconButton>
    </Box>

    <Box sx={{ flex: 1, overflow: 'auto', p: 2, backgroundColor: 'background.paper' }}>{children}</Box>

    {actions && (
      <Stack
        direction="row"
        spacing={1}
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          boxShadow: 2,
          backgroundColor: 'background.paper',
        }}
      >
        {actions}
      </Stack>
    )}
  </Drawer>
);
